import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import EyeIcon from '@wix/da-ds/pkg/Icons/Eye';
import UnwatchIcon from '@wix/da-ds/pkg/Icons/Unwatch';
import { CommentContext } from '../CommentContext';
import { canPeek } from '../../utils';
import s from './HiddenCommentBody.scss';
var HiddenCommentBody = function (_a) {
    var className = _a.className;
    var t = useTranslation().t;
    var _b = useContext(CommentContext), setPeeking = _b.setPeeking, comment = _b.comment;
    return (React.createElement("div", { className: className, "data-commentid": comment.commentId, "data-typeid": comment.typeId, "data-itemid": comment.itemId },
        canPeek(comment) && (React.createElement("button", { className: s['hidden-but-viewable'], onClick: function () { return setPeeking(true); } },
            React.createElement("span", { className: s['hidden-text'] },
                React.createElement(UnwatchIcon, { className: s['hidden-icon'] }),
                t('comment.visibility.hidden')),
            React.createElement("span", { className: s['hidden-text-hover'] },
                React.createElement(EyeIcon, { className: s['hidden-icon'] }),
                t('comment.visibility.hidden.showComment')))),
        !canPeek(comment) && (React.createElement("button", { className: s['hidden'] },
            React.createElement("span", { className: s['hidden-text'] },
                React.createElement(UnwatchIcon, { className: s['hidden-icon'] }),
                t('comment.visibility.hidden'))))));
};
HiddenCommentBody.displayName = 'HiddenCommentBody';
export default HiddenCommentBody;
//# sourceMappingURL=HiddenCommentBody.js.map